/**
 * Oase Living — global.js
 * Kleine, progressive-enhancement JavaScript. De storefront werkt volledig
 * zonder JS; dit script verbetert alleen de interactie.
 *
 *  - Mobiele navigatie-toggle
 *  - Quantity-stepper (+/-)
 *  - Variant-selector die de URL/prijs bijwerkt via native formulier
 */
(function () {
  'use strict';

  /* ---------- Locale-aware routes (Shopify Markets: /en, /nl-be, …) ----------
     Alle Ajax-routes moeten de market-root respecteren, anders valt een bezoeker
     in een subfolder-market terug naar de standaardtaal/valuta. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function shopUrl(path) { return ROOT + path; }

  /* ---------- Header-stack: scrolled-state (class op de wrapper) ---------- */
  (function () {
    var stack = document.querySelector('[data-header-stack]');
    if (!stack) return;
    var overlay = stack.classList.contains('is-overlay');
    // Bij overlay-hero pas omschakelen na ~halve viewport (voorbij de vouw),
    // zodat de witte sticky header pas verschijnt als het beeld uit zicht is.
    var threshold = overlay ? Math.round(Math.min(window.innerHeight * 0.5, 400)) : 8;
    var onScroll = function () {
      stack.classList.toggle('is-scrolled', window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- Mobiele navigatiedrawer (met focus trap) ---------- */
  (function () {
    var drawer = document.querySelector('[data-nav-panel]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-nav-toggle][aria-controls]');
    var lastFocused = null;
    var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var focusable = function () {
      return Array.prototype.slice
        .call(drawer.querySelectorAll(focusableSel))
        .filter(function (el) { return el.offsetParent !== null; });
    };
    var setOpen = function (open) {
      drawer.toggleAttribute('data-open', open);
      document.documentElement.toggleAttribute('data-menu-open', open);
      openers.forEach(function (o) { o.setAttribute('aria-expanded', String(open)); });
      if (open) {
        lastFocused = document.activeElement;
        var f = focusable();
        if (f.length) f[0].focus();
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    };
    document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () { setOpen(!drawer.hasAttribute('data-open')); });
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key === 'Tab') {
        var f = focusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('[data-quantity]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    if (!input) return;

    wrapper.querySelectorAll('[data-quantity-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = button.getAttribute('data-quantity-button') === 'increase' ? 1 : -1;
        var min = parseInt(input.min, 10) || 1;
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Productpagina: varianten + mediagalerij ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selectors = Array.prototype.slice.call(root.querySelectorAll('[data-option-selector]'));
    var idInput = root.querySelector('[data-variant-id]');

    // Aantal optie-assen (bv. Kleur + Maat) o.b.v. de hoogste option-index.
    var optionCount = selectors.reduce(function (max, el) {
      var i = parseInt(el.getAttribute('data-option-index'), 10) || 0;
      return Math.max(max, i + 1);
    }, 0);

    // Verzamel de gekozen waarde per optie-as.
    // Werkt zowel met <select> als met radio-knoppen (swatches).
    var chosenOptions = function () {
      var chosen = new Array(optionCount);
      selectors.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10) || 0;
        if (el.tagName === 'SELECT') {
          chosen[idx] = el.value;
        } else if (el.type === 'radio') {
          if (el.checked) chosen[idx] = el.value;
        } else {
          chosen[idx] = el.value;
        }
      });
      return chosen;
    };
    var priceWrap = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyAtc = document.querySelector('[data-product-sticky] .product-sticky__atc');
    var availabilityEl = root.querySelector('[data-availability]');
    var currency = root.getAttribute('data-currency') || 'EUR';
    var locale = document.documentElement.lang || 'nl';

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };

    /* ---------- Galerij: scroll-snap carrousel + thumbs + dots ---------- */
    var stage = root.querySelector('[data-stage]');
    var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('.product__slide')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-target]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var galleryEl = root.querySelector('[data-media-gallery]');
    var variantFilterOn = !!(galleryEl && galleryEl.hasAttribute('data-variant-filter'));
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var accentMap = { 'á': 'a', 'à': 'a', 'ä': 'a', 'â': 'a', 'é': 'e', 'è': 'e', 'ë': 'e', 'ê': 'e', 'í': 'i', 'ï': 'i', 'ó': 'o', 'ö': 'o', 'ô': 'o', 'ú': 'u', 'ü': 'u', 'ç': 'c' };
    var normKey = function (s) {
      return (s || '').toString().toLowerCase()
        .replace(/[áàäâéèëêíïóöôúüç]/g, function (m) { return accentMap[m] || m; })
        .replace(/[^a-z0-9]/g, '');
    };

    var setActiveIndex = function (index) {
      thumbs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-index'), 10) === index;
        t.classList.toggle('is-active', on);
        if (on && t.scrollIntoView) t.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: prefersReduced ? 'auto' : 'smooth' });
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-dot'), 10) === index);
      });
    };

    var scrollToIndex = function (index) {
      if (!stage || !slides[index]) return;
      // offsetLeft i.p.v. index*breedte: robuust bij verborgen slides (variantfilter) én desktop-grid
      stage.scrollTo({ left: slides[index].offsetLeft, behavior: prefersReduced ? 'auto' : 'smooth' });
    };

    var setActiveMedia = function (mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') == mediaId) {
          scrollToIndex(i);
          setActiveIndex(i);
          break;
        }
      }
    };

    if (stage) {
      var scrollTimer = null;
      stage.addEventListener('scroll', function () {
        if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
        scrollTimer = window.requestAnimationFrame(function () {
          var index = Math.round(stage.scrollLeft / stage.clientWidth);
          setActiveIndex(index);
        });
      }, { passive: true });
    }

    var findVariant = function () {
      var chosen = chosenOptions();
      return variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
    };

    // Houd de swatch-UI in sync met de gekozen radio's (visuele selectie + labeltekst).
    var syncSwatchUi = function () {
      var chosen = chosenOptions();
      root.querySelectorAll('.product__swatch').forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        if (input) label.classList.toggle('is-selected', input.checked);
      });
      root.querySelectorAll('[data-option-value-for]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-value-for'), 10) || 0;
        if (chosen[idx] != null) el.textContent = chosen[idx];
      });
    };

    // Combinatiebewuste beschikbaarheid: test per optiewaarde de VOLLEDIGE combinatie
    // (deze waarde + de reeds gekozen waarden van de overige assen) tegen product.variants.
    //   · bestaat niet          → .is-unavailable + disabled (niet selecteerbaar)
    //   · bestaat, uitverkocht  → .is-soldout + disabled
    //   · bestaat, beschikbaar  → normaal
    // De reeds geselecteerde waarde wordt nooit disabled (voorkomt vastlopen/omschakelen).
    var refreshAvailability = function () {
      var chosen = chosenOptions();
      selectors.forEach(function (input) {
        if (input.type !== 'radio') return; // swatches zijn radio's
        var idx = parseInt(input.getAttribute('data-option-index'), 10) || 0;
        var value = input.value;
        var isSelected = input.checked;
        var exists = false, availableExists = false;
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k];
          if (v.options[idx] !== value) continue;
          var matchOthers = true;
          for (var j = 0; j < optionCount; j++) {
            if (j === idx) continue;
            if (chosen[j] != null && v.options[j] !== chosen[j]) { matchOthers = false; break; }
          }
          if (!matchOthers) continue;
          exists = true;
          if (v.available) { availableExists = true; break; }
        }
        var nonExistent = !exists;
        var soldOut = exists && !availableExists;
        var disable = (nonExistent || soldOut) && !isSelected;
        input.disabled = disable;
        if (disable) input.setAttribute('aria-disabled', 'true'); else input.removeAttribute('aria-disabled');
        var label = input.closest('.product__swatch');
        if (label) {
          label.classList.toggle('is-unavailable', nonExistent);
          label.classList.toggle('is-soldout', soldOut);
        }
      });
    };

    var updateVariant = function () {
      syncSwatchUi();
      refreshAvailability();
      var variant = findVariant();
      if (!variant) {
        if (atc) { atc.setAttribute('disabled', ''); }
        if (atcLabel) atcLabel.textContent = atcLabel.getAttribute('data-unavailable') || 'Niet beschikbaar';
        return;
      }
      if (idInput) idInput.value = variant.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (priceWrap) {
        var html = '<div class="price ' + (variant.compare_at_price > variant.price ? 'price--on-sale' : '') + ' product__price">';
        if (variant.compare_at_price > variant.price) {
          html += '<span class="price__current">' + money(variant.price) + '</span>';
          html += '<s class="price__compare">' + money(variant.compare_at_price) + '</s>';
        } else {
          html += '<span class="price__current">' + money(variant.price) + '</span>';
        }
        html += '</div>';
        priceWrap.innerHTML = html;
      }

      if (atc) {
        if (variant.available) {
          atc.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = atcLabel.getAttribute('data-available') || atcLabel.textContent;
        } else {
          atc.setAttribute('disabled', '');
          if (atcLabel) atcLabel.textContent = atcLabel.getAttribute('data-soldout') || 'Uitverkocht';
        }
      }

      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyAtc) { if (variant.available) stickyAtc.removeAttribute('disabled'); else stickyAtc.setAttribute('disabled', ''); }

      if (availabilityEl) { if (variant.available) availabilityEl.removeAttribute('data-out'); else availabilityEl.setAttribute('data-out', ''); }

      // GPSR: SKU/EAN volgen de geselecteerde variant
      var skuEl = root.querySelector('[data-variant-sku]');
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        var skuWrap = skuEl.closest('[data-sku-wrap]');
        if (skuWrap) skuWrap.toggleAttribute('hidden', !variant.sku);
      }
      var barEl = root.querySelector('[data-variant-barcode]');
      if (barEl) {
        barEl.textContent = variant.barcode || '';
        var barWrap = barEl.closest('[data-barcode-wrap]');
        if (barWrap) barWrap.toggleAttribute('hidden', !variant.barcode);
      }

      if (variantFilterOn) {
        applyVariantMedia();
      } else if (variant.featured_media) {
        setActiveMedia(variant.featured_media.id);
      }
    };

    // Optioneel: media filteren per variant via alt-suffix "| variant:key" (data-variant-tag).
    // Media zonder tag blijft altijd zichtbaar; verborgen media krijgt [hidden]. Default uit.
    var applyVariantMedia = function () {
      if (!variantFilterOn) return;
      var chosenSet = {};
      chosenOptions().forEach(function (v) { var k = normKey(v); if (k) chosenSet[k] = true; });
      var firstVisible = null;
      var toggle = function (el) {
        var tag = (el.getAttribute('data-variant-tag') || '').trim();
        var show = !tag || chosenSet[tag] === true;
        el.hidden = !show;
        return show;
      };
      slides.forEach(function (sl) { if (toggle(sl) && firstVisible === null) firstVisible = sl; });
      thumbs.forEach(function (th) { toggle(th); });
      if (firstVisible) {
        var idx = parseInt(firstVisible.getAttribute('data-index'), 10) || 0;
        scrollToIndex(idx);
        setActiveIndex(idx);
      }
    };

    selectors.forEach(function (s) { s.addEventListener('change', updateVariant); });
    refreshAvailability(); // init: deep-link / server-geselecteerde variant → juiste disabled-states
    applyVariantMedia();   // init: pas variant-mediafilter toe (no-op wanneer uitgeschakeld of geen tags)

    // Klikbare thumbnails → scroll de carrousel naar het juiste beeld
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        scrollToIndex(index);
        setActiveIndex(index);
      });
    });

    // Galerij-pijlen ‹ ›
    var currentIndex = function () { return stage ? Math.round(stage.scrollLeft / stage.clientWidth) : 0; };
    var prevBtn = root.querySelector('[data-stage-prev]');
    var nextBtn = root.querySelector('[data-stage-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { var i = Math.max(0, currentIndex() - 1); scrollToIndex(i); setActiveIndex(i); });
    if (nextBtn) nextBtn.addEventListener('click', function () { var i = Math.min(slides.length - 1, currentIndex() + 1); scrollToIndex(i); setActiveIndex(i); });

    /* ---------- Zoom-lightbox ---------- */
    var lightbox = document.querySelector('[data-lightbox]');
    if (lightbox) {
      var lbScroll = lightbox.querySelector('[data-lightbox-scroll]');
      var lbImg = document.createElement('img');
      lbImg.className = 'product-lightbox__img';
      lbImg.alt = lbScroll ? (lbScroll.getAttribute('data-lightbox-alt') || '') : '';
      if (lbScroll) lbScroll.appendChild(lbImg);
      var openLightbox = function (src) {
        if (!src) return;
        lbImg.src = src;
        lbImg.classList.remove('is-zoomed');
        lightbox.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      };
      var closeLightbox = function () {
        lightbox.setAttribute('hidden', '');
        lbImg.classList.remove('is-zoomed');
        document.body.style.overflow = '';
      };
      root.querySelectorAll('[data-zoom-src]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          openLightbox(trigger.getAttribute('data-zoom-src'));
        });
      });
      var zoomOpen = root.querySelector('[data-zoom-open]');
      if (zoomOpen) zoomOpen.addEventListener('click', function () {
        var idx = stage ? Math.round(stage.scrollLeft / stage.clientWidth) : 0;
        var slide = slides[idx];
        var trig = slide && slide.querySelector('[data-zoom-src]');
        if (trig) openLightbox(trig.getAttribute('data-zoom-src'));
      });
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        lbImg.classList.toggle('is-zoomed');
      });
      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
      if (lbScroll) lbScroll.addEventListener('click', function (e) { if (e.target === lbScroll) closeLightbox(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) closeLightbox();
      });
    }
  });

  /* ---------- Sticky mobiele koopbalk (toont zodra de ATC uit beeld is) ---------- */
  (function () {
    var bar = document.querySelector('[data-product-sticky]');
    var atc = document.querySelector('[data-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      bar.toggleAttribute('data-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    observer.observe(atc);
  })();

  /* ---------- Predictive search (elke [data-predictive] root) ---------- */
  var predictiveCache = {};
  document.querySelectorAll('[data-predictive]').forEach(function (root) {
    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer = null;
    var controller = null;

    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('.predictive__results, .predictive__empty');
      results.innerHTML = content ? content.outerHTML : '';
    }

    function search(term) {
      var key = term.toLowerCase();
      if (predictiveCache[key]) { render(predictiveCache[key]); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var url =
        shopUrl('search/suggest?q=') +
        encodeURIComponent(term) +
        '&section_id=predictive-search&resources[type]=product,page,article&resources[limit]=6';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          predictiveCache[key] = html;
          render(html);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () { search(term); }, 250);
    });
  });

  /* ---------- Zoek-overlay open/sluiten (desktop) ---------- */
  (function () {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    var toggle = document.querySelector('[data-search-toggle]');
    var input = overlay.querySelector('[data-predictive-input]');
    var closers = overlay.querySelectorAll('[data-search-close]');

    function open() {
      overlay.toggleAttribute('data-open', true);
      document.documentElement.toggleAttribute('data-menu-open', true);
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function close() {
      overlay.removeAttribute('data-open');
      document.documentElement.removeAttribute('data-menu-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) toggle.addEventListener('click', open);
    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.hasAttribute('data-open')) close();
    });
  })();

  /* ---------- Productaanbevelingen (lazy via Recommendations API) ---------- */
  document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Centrale cart-controller (drawer + AJAX + section rendering) ----------
     Eén bron van waarheid: add/change/remove/open/close, cart-teller, events.
     Alle bedragen/totalen komen uit Shopify. Progressive enhancement: zonder JS
     blijven de normale formulieren en /cart werken. */
  (function () {
    var SECTION = 'cart-drawer';
    var drawer = document.querySelector('[data-cart-drawer]');
    var hasDrawer = !!drawer && window.fetch;
    var lastFocused = null;

    function contentEl() { return drawer && drawer.querySelector('[data-cart-drawer-content]'); }
    function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {} }

    function updateCount(count) {
      document.querySelectorAll('.header__cart').forEach(function (link) {
        var b = link.querySelector('.header__cart-count');
        if (count > 0) {
          if (!b) { b = document.createElement('span'); b.className = 'header__cart-count'; b.setAttribute('aria-hidden', 'true'); link.appendChild(b); }
          b.textContent = count;
        } else if (b) { b.remove(); }
      });
    }

    function focusable(el) {
      return Array.prototype.slice
        .call(el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (e) { return e.offsetParent !== null; });
    }

    function open() {
      if (!hasDrawer) return;
      lastFocused = document.activeElement;
      drawer.setAttribute('data-open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('data-cart-open', '');
      // Focus het dialoogpaneel (tabindex=-1), niet de eerste knop: focus trap blijft
      // werken, maar de drawer opent niet visueel alsof de sluitknop geselecteerd is.
      var panel = drawer.querySelector('[data-cart-drawer-panel]');
      if (panel && panel.focus) { panel.focus(); }
      else { var f = focusable(drawer); if (f.length) f[0].focus(); }
      emit('cart:drawer:open');
    }
    function close() {
      if (!drawer) return;
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('data-cart-open');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      emit('cart:drawer:close');
    }

    function renderSections(sections) {
      var html = sections && sections[SECTION];
      var cur = contentEl();
      if (!html || !cur) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-content]');
      if (!fresh) return;
      cur.innerHTML = fresh.innerHTML;
      var c = fresh.querySelector('.cd__count');
      updateCount(c ? (parseInt(c.textContent.replace(/[^0-9]/g, ''), 10) || 0) : 0);
    }

    function post(url, body) {
      body.sections = [SECTION];
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) { d._status = r.status; throw d; } return d; }); });
    }

    // Serialiseer mutaties → geen race conditions / stale HTML
    var chain = Promise.resolve();
    function queue(fn) { var run = chain.then(fn, fn); chain = run.catch(function () {}); return run; }

    var Cart = {
      open: open, close: close,
      refresh: function () {
        return fetch(shopUrl('?sections=' + SECTION), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(renderSections);
      },
      add: function (items, opts) {
        opts = opts || {};
        emit('cart:adding', { items: items });
        return queue(function () {
          return post(shopUrl('cart/add.js'), { items: items }).then(function (res) {
            renderSections(res.sections);
            emit('cart:updated', {});
            if (hasDrawer && opts.openDrawer !== false) open();
            return res;
          }).catch(function (err) { emit('cart:error', { error: err }); throw err; });
        });
      },
      change: function (key, quantity) {
        return queue(function () {
          return post(shopUrl('cart/change.js'), { id: key, quantity: quantity }).then(function (cart) {
            updateCount(cart.item_count);
            renderSections(cart.sections);
            emit('cart:updated', { cart: cart });
            return cart;
          }).catch(function (err) { emit('cart:error', { error: err }); throw err; });
        });
      }
    };
    window.OaseCart = Cart;

    // Header-winkelmand → open drawer i.p.v. navigeren
    if (hasDrawer) {
      document.querySelectorAll('.header__cart').forEach(function (link) {
        link.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
    }

    // Quick-add (product-card enkelvoudige variant) → AJAX + drawer
    document.querySelectorAll('[data-quick-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // fallback: normale submit → /cart
        e.preventDefault();
        var btn = form.querySelector('button');
        var id = form.querySelector('[name="id"]');
        if (!id) { form.submit(); return; }
        if (btn) btn.setAttribute('aria-busy', 'true');
        Cart.add([{ id: parseInt(id.value, 10), quantity: 1 }]).then(function () {
          if (btn) { btn.removeAttribute('aria-busy'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
        }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); /* fout wordt zichtbaar in de drawer via cart:error */ });
      });
    });

    // PDP-productformulier → AJAX + drawer
    var pform = document.getElementById('product-form');
    if (pform && hasDrawer) {
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = pform.querySelector('[data-atc]');
        var id = pform.querySelector('[data-variant-id]') || pform.querySelector('[name="id"]');
        var qty = pform.querySelector('[name="quantity"]');
        if (!id || (atc && atc.hasAttribute('disabled'))) return;
        if (atc) atc.setAttribute('aria-busy', 'true');
        Cart.add([{ id: parseInt(id.value, 10), quantity: qty ? (parseInt(qty.value, 10) || 1) : 1 }])
          .then(function () { if (atc) atc.removeAttribute('aria-busy'); })
          .catch(function () { if (atc) atc.removeAttribute('aria-busy'); /* fout wordt zichtbaar in de drawer via cart:error */ });
      });
    }

    // Set-module → voeg alle componenten samen toe (Optie C, line-item properties)
    document.querySelectorAll('[data-set-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!hasDrawer) return;
        var items;
        try { items = JSON.parse(btn.getAttribute('data-set-add')); } catch (e) { return; }
        if (!items || !items.length) return;
        btn.setAttribute('aria-busy', 'true');
        Cart.add(items).then(function () { btn.removeAttribute('aria-busy'); })
          .catch(function () { btn.removeAttribute('aria-busy'); });
      });
    });

    // Gedelegeerde interacties binnen de drawer
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); close(); return; }
      var qbtn = e.target.closest('[data-cart-qty-btn]');
      if (qbtn) {
        var wrap = qbtn.closest('[data-cart-qty]');
        var input = wrap.querySelector('[data-cart-qty-input]');
        var key = wrap.getAttribute('data-line-key');
        var step = qbtn.getAttribute('data-cart-qty-btn') === 'increase' ? 1 : -1;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        var line = qbtn.closest('.cd-line'); if (line) line.setAttribute('data-line-busy', '');
        Cart.change(key, next);
        return;
      }
      var rem = e.target.closest('[data-cart-remove]');
      if (rem) { e.preventDefault(); var l = rem.closest('.cd-line'); if (l) l.setAttribute('data-line-busy', ''); Cart.change(rem.getAttribute('data-line-key'), 0); return; }
      var remg = e.target.closest('[data-cart-remove-group]');
      if (remg) { e.preventDefault(); removeGroup(remg.getAttribute('data-cart-remove-group')); return; }
      var upg = e.target.closest('[data-cart-upgrade]');
      if (upg) {
        e.preventDefault();
        var udata;
        try { udata = JSON.parse(upg.getAttribute('data-cart-upgrade')); } catch (err) { return; }
        if (!udata || !udata.add) return;
        upg.setAttribute('aria-busy', 'true');
        var undone = function () { upg.removeAttribute('aria-busy'); };
        var ustep = Promise.resolve();
        if (udata.remove) { ustep = ustep.then(function () { return Cart.change(udata.remove, 0); }); }
        ustep.then(function () { return Cart.add(udata.add, { openDrawer: false }); }).then(undone, undone);
        return;
      }
      var up = e.target.closest('[data-cart-add]');
      if (up) { e.preventDefault(); up.disabled = true; Cart.add([{ id: parseInt(up.getAttribute('data-cart-add'), 10), quantity: 1 }]).catch(function () { up.disabled = false; }); return; }
    });

    function removeGroup(gid) {
      fetch(shopUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var keys = cart.items.filter(function (it) { return it.properties && it.properties._bundle_group_id === gid; }).map(function (it) { return it.key; });
        (function next() { if (!keys.length) return; Cart.change(keys.shift(), 0).then(next, next); })();
      });
    }

    // Zichtbare Ajax-cart-fout: toon Shopify's foutbericht (of een generieke tekst)
    document.addEventListener('cart:error', function (e) {
      if (!drawer) return;
      var region = drawer.querySelector('[data-cart-error]');
      if (!region) return;
      var err = e.detail && e.detail.error;
      var msg = (err && (err.description || err.message)) || region.getAttribute('data-error-generic') || '';
      region.textContent = msg;
      region.hidden = false;
      var busy = drawer.querySelectorAll('[data-line-busy]');
      Array.prototype.forEach.call(busy, function (l) { l.removeAttribute('data-line-busy'); });
      open();
    });

    // Escape + focus trap in de drawer
    document.addEventListener('keydown', function (e) {
      if (!drawer || !drawer.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusable(drawer); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ---------- Facets: sorteer-select auto-submit ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.form || select.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Filter-drawer (collectie) met focus trap ---------- */
  (function () {
    var panel = document.querySelector('[data-facet-panel]');
    if (!panel) return;
    var opener = document.querySelector('[data-facet-toggle][aria-controls]');
    var lastFocused = null;
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var focusable = function () {
      return Array.prototype.slice.call(panel.querySelectorAll(sel)).filter(function (el) { return el.offsetParent !== null; });
    };
    var setOpen = function (open) {
      panel.toggleAttribute('data-open', open);
      document.documentElement.toggleAttribute('data-facet-open', open);
      if (opener) opener.setAttribute('aria-expanded', String(open));
      if (open) {
        lastFocused = document.activeElement;
        var f = focusable();
        if (f.length) f[0].focus();
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    };
    document.querySelectorAll('[data-facet-toggle]').forEach(function (t) {
      t.addEventListener('click', function () { setOpen(!panel.hasAttribute('data-open')); });
    });
    document.addEventListener('keydown', function (e) {
      if (!panel.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key === 'Tab') {
        var f = focusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ---------- Adres: land/provincie-koppeling ---------- */
  /* shopify_common.js wordt op de adrespagina deferred geladen vóór dit script. */
  if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
    document.querySelectorAll('[id^="AddressCountry_"]').forEach(function (countrySelect) {
      var prefix = countrySelect.id.replace('AddressCountry_', '');
      var province = document.getElementById('AddressProvince_' + prefix);
      var container = document.getElementById('AddressProvinceContainer_' + prefix);
      if (!province || !container) return;
      new Shopify.CountryProvinceSelector(countrySelect.id, province.id, {
        hideElement: container.id,
      });
    });
  }
})();
